import axios from "axios";

export const read = async (skip,query,searchThis) => {
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listPI?skip=${skip}&query=${query}&searchItem=${searchThis}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}